import React from "react";
import { FaPhoneAlt } from "react-icons/fa";

const HelpWidget: React.FC = () => {
  const phoneNumber = "912240003434";

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end">
      <a
        href={`tel:+${phoneNumber}`}
        aria-label="Call support"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-pink text-white shadow-lg transition hover:bg-brand-dark active:scale-95"
      >
        <FaPhoneAlt className="text-2xl" />
      </a>
    </div>
  );  
};

export default HelpWidget;
